"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Icon = exports.Icon = _styledComponents["default"].div.withConfig({
  displayName: "styles__Icon",
  componentId: "sc-15i3r3v-0"
})(["display:inline-block;height:", "px;vertical-align:", ";width:", "px;", " > svg{display:block;height:100%;width:100%;", "}"], function (p) {
  return p.size;
}, function (p) {
  return p.valign;
}, function (p) {
  return p.size;
}, function (p) {
  return p.onClick && "\n    cursor: pointer;\n  ";
}, function (p) {
  return p.shouldInheritTextColor && "\n      path {\n        fill: currentColor;\n      }\n    ";
});
//# sourceMappingURL=styles.js.map